module.exports = __webpack_public_path__ + "static/media/LK__mail.f558a095.svg";